import { render, staticRenderFns } from "./order-refund.vue?vue&type=template&id=a880a81a&scoped=true&"
import script from "./order-refund.vue?vue&type=script&lang=tsx&"
export * from "./order-refund.vue?vue&type=script&lang=tsx&"
import style0 from "./order-refund.vue?vue&type=style&index=0&id=a880a81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a880a81a",
  null
  
)

export default component.exports